export const styles = (theme) => ({

closeButton:{
    width: "30px",
    height: "30px",
    background: "#242424",
    minWidth: "inherit",
    // position: "absolute",
    right: "0px",
    float:"right",
    "& svg":{
        fontSize: "17px",
    }
},
 
dataViewContainer:{
    "& .MuiPaper-rounded":{
        background: "#353535", 
        height: "auto !important",
    },
    "& > div.MuiPaper-rounded":{
        height: "auto !important",
    },
    "&  .MuiBox-root":{
        padding: "10px !important"
    },
    "& .MuiBox-root .MuiPaper-root":{      
         height: "auto !important",
    },
    "& .ctagWindow":{
        height: "auto !important",
        minHeight:"400px",
        padding:"0px !important",
        position:"relative", 
        left: "inherit",
        right: "inherit",
        "& .noData":{
                top: "50%",
                left: "0px",
                right: "0px",
                width: "100%",
                position: "absolute",
                fontSize: "12px",
                textAlign: "center",
        },
         "& .MuiChip-root": {
                margin: "0px 5px 8px 0",
                background: "#272727",
                border: "none",
                color:"#ffcb00",
                height: "inherit",
                minHeight: "30px",
                fontSize: "13px",
                display: "inline-flex",
                alignItems: "center",
                borderRadius: "16px",
                "& .MuiChip-label":{
                    whiteSpace: "pre-wrap",
                    padding: "0 12px",
                }
  },
    },
    "& .popupWindow":{
        height: "auto !important",
        minHeight:"400px",
        padding:"0px !important",
        position:"relative",
        "& .noData":{
                top: "50%",
                left: "0px",
                right: "0px",
                width: "100%",
                position: "absolute",
                fontSize: "12px",
                textAlign: "center",
        },
         "& .MuiChip-root": {
                margin: "0px 5px 8px 0",
                background: "#272727",
                border: "none",
                color:"#ffcb00",
                height: "inherit",
                minHeight: "30px",
                fontSize: "13px",
                display: "inline-flex",
                alignItems: "center",
                borderRadius: "16px",
                "& .MuiChip-label":{
                    whiteSpace: "pre-wrap",
                    padding: "0 12px",
                }
  },
    },
    "& .popupData":{
        alignItems:"center",
    }
},
muLabels: {
    width: "40%",
    textTransform: "uppercase",
    color: "#dcdcdc",
    fontSize: "0.7em",
    display: "inline-block",
    verticalAlign: "top",
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingLeft:"10px",
  },
trackTags:{
    marginBottom: "15px",
    borderBottom: "1px solid #6b6b6b",
    paddingBottom: "5px",
    "& label":{
      display:"block",
      margin:"10px 0 10px 0",
      color: "#DEDEDE",
      textTransform:"uppercase",
      fontSize:"0.7em",
    },
    "& .MuiChip-root": {
      margin: "0px 5px 8px 0",
      background: "#272727",
    border: "none",
    color:"#ffcb00",
    height: "inherit",
    minHeight: "30px",
    fontSize: "14px",
    "& .MuiChip-label":{
      whiteSpace: "pre-wrap",
    }
  },
},
    noData:{
    top: "50%",
    left: "0px",
    right: "0px",
    width: "100%",
    position: "absolute",
    fontSize: "12px",
    textAlign: "center",
    },
modalPopupWrap:{
    "& .MuiDialog-paper":{
        minWidth:"1000px",
        textAlign:"left",
        maxWidth:"1024px",
        "& .waveImageInBuilt":{
            top:"10px"
          }
    },
    "& .MuiDialogTitle-root": {
        padding: "8px 12px 0px 12px",
    },
},
artistName:{
     fontSize: "11px",
     color:"#D2D2D2"
},
headTag:{
    fontSize: "1.2em",
    fontWeight: "400",
    color: "#fff",
    lineHeight: "1",
    maxWidth:"98%", 
},
playerPopContainer:{
    marginTop:"20px",
    "& > div":{
        paddingLeft:"0 !important",
        margin:"0",
        width:"100%",
    },
    "& .duration-container":{
        right: "12px",
        marginTop: "40px",
    },
    "& .popupWave":{
        height:"57px !important",
    },
    "& .MuiSlider-root":{
        marginTop: "0",
        marginLeft: "5px",
        marginRight: "15px",
    },
    "& .MuiCircularProgress-indeterminate":{
        width: "20px !important", 
       height: "20px !important",
        margin: "20px auto",
        position: "relative !important",
        color: "#fff !important",
   }
}, 
innerPadding:{
    "& .popupProgress ":{
        height: "57px",
        "& .waveImage":{
            // filter: "brightness(0) invert(1)",
            width: "100%",
            height: "57px",
            position: "absolute",
            imageRendering: "pixelated !important",
        }
    },
    paddingLeft:"0",
    marginBottom:"10px"
},
imgContainer:{
    padding:"10px 20px 20px 0px",
    "& img":{
        boxShadow:"0 0 5px #000",
    }
}
});